import styled from 'styled-components';

export const CouponExpiry = styled('div')`
  ${({ theme }) => theme.typography.xSmall}
  background-color: ${({ theme }) => theme.color.bad};
  color: ${({ theme }) => theme.color.white};
  padding: 6px 12px;
  border-radius: 8px;
  width: fit-content;
  margin: 0 auto;
`;

export const CouponOffer = styled('span')`
  display: inline-block;
  ${({ theme }) => theme.typography.base}
  color: ${({ theme }) => theme.color.bad};
  text-decoration: line-through;
  span {
    color: ${({ theme }) => theme.color.spaceGray};
  }
  margin-bottom: 8px;
`;

export const PlanOfferContainer = styled('div')`
  margin-top: -8px;
  margin-bottom: 12px;
`;
